<div class="w-full bg-white rounded-xl shadow-lg py-5">
  <div class="flex flex-col items-center">
    <div class="flex flex-row justify-between w-full pr-7 gap-3 mb-4">
      <p class="font-semibold text-2xl pl-7 w-46.5">Test Cases</p>
      @if (!isForVerify()) {
        @if (!running()) {
        <div class="flex flex-row gap-2">
          <div class="h-full">
            <app-button
              color="secondary"
              label="Run Test"
              size="medium"
              (clicked)="handleRunTestClick()"
              [disabled]="disabled()" />
          </div>
          <div class="h-full">
            <app-button
              color="primary"
              label="Submit"
              size="medium"
              (clicked)="handleSubmitClick()"
              [disabled]="disabled()" />
          </div>
        </div>
        } @else {
          <p class="font-semibold text-xl">Running . . .</p>
        }
      } @else {
        @if (!running()) {
          <div class="h-full">
            <app-button
              color="primary"
              label="RUN"
              size="medium"
              (clicked)="handleSubmitClick()" />
          </div>
      } @else {
        <p class="font-semibold text-xl">Running . . .</p>
      }
    }
  </div>
  @if (testCaseResultArray().length > 0) {
    <div class="flex flex-row h-full w-full pt-5">
      <div
        class="w-[198px] h-[65%] overflow-y-auto overflow-x-hidden no-scrollbar pr-20">
        @for (item of testCaseResultArray(); track item.testCaseId) {
          @if(item.isVisible || isForVerify()) {
            <button
              class="w-[186px] flex items-center justify-center py-4 hover:cursor-pointer hover:bg-slate-100 focus:bg-slate-100"
              (click)="select(item.testCaseId)"
              id="btn-test-case">
              <div class="flex flex-row gap-2 justify-center items-center">
                @if (item.passed) {
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.4866 3.78628L5.81996 13.1196C5.69431 13.2551 5.51807 13.3323 5.33329 13.3329C5.15609 13.334 4.98577 13.2644 4.85996 13.1396L1.52663 9.80628C1.26521 9.54486 1.26521 9.12102 1.52663 8.85961C1.78804 8.59819 2.21188 8.59819 2.47329 8.85961L5.33329 11.7063L13.5133 2.87961C13.6702 2.68612 13.9219 2.59625 14.1658 2.64659C14.4098 2.69693 14.6053 2.87908 14.6728 3.11887C14.7403 3.35866 14.6685 3.61607 14.4866 3.78628Z"
                      fill="#00C950" />
                  </svg>
                } @else {
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.4735 13.5271C14.5997 13.6523 14.6707 13.8227 14.6707 14.0005C14.6707 14.1782 14.5997 14.3486 14.4735 14.4738C14.3483 14.6 14.1779 14.671 14.0001 14.671C13.8224 14.671 13.652 14.6 13.5268 14.4738L8.00012 8.94046L2.47346 14.4738C2.34828 14.6 2.17788 14.671 2.00012 14.671C1.82236 14.671 1.65197 14.6 1.52679 14.4738C1.40058 14.3486 1.32959 14.1782 1.32959 14.0005C1.32959 13.8227 1.40058 13.6523 1.52679 13.5271L7.06012 8.00046L1.52679 2.4738C1.35768 2.30469 1.29164 2.05822 1.35354 1.82721C1.41543 1.59621 1.59587 1.41578 1.82687 1.35388C2.05787 1.29198 2.30435 1.35803 2.47346 1.52713L8.00012 7.06046L13.5268 1.52713C13.7882 1.26572 14.212 1.26572 14.4735 1.52713C14.7349 1.78855 14.7349 2.21238 14.4735 2.4738L8.94012 8.00046L14.4735 13.5271Z"
                      fill="#FB2C36" />
                  </svg>
                }
                <p class="text-sm font-semibold" [class.pr-6]="!isForVerify()">Test Case {{ $index + 1 }}</p>
                @if (isForVerify()) {
                  <p class="text-xs text-gray-400">({{ item.isVisible ? 'Visible' : 'Hidden' }})</p>
                }
              </div>
            </button>
          } @else {
            <button
              class="w-[186px] flex items-center justify-center py-4 hover:cursor-not-allowed"
              (click)="$event.preventDefault()">
              <div class="flex flex-row gap-2 justify-center items-center">
                @if (item.passed) {
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.4866 3.78628L5.81996 13.1196C5.69431 13.2551 5.51807 13.3323 5.33329 13.3329C5.15609 13.334 4.98577 13.2644 4.85996 13.1396L1.52663 9.80628C1.26521 9.54486 1.26521 9.12102 1.52663 8.85961C1.78804 8.59819 2.21188 8.59819 2.47329 8.85961L5.33329 11.7063L13.5133 2.87961C13.6702 2.68612 13.9219 2.59625 14.1658 2.64659C14.4098 2.69693 14.6053 2.87908 14.6728 3.11887C14.7403 3.35866 14.6685 3.61607 14.4866 3.78628Z"
                      fill="#00C950" />
                  </svg>
                } @else {
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.4735 13.5271C14.5997 13.6523 14.6707 13.8227 14.6707 14.0005C14.6707 14.1782 14.5997 14.3486 14.4735 14.4738C14.3483 14.6 14.1779 14.671 14.0001 14.671C13.8224 14.671 13.652 14.6 13.5268 14.4738L8.00012 8.94046L2.47346 14.4738C2.34828 14.6 2.17788 14.671 2.00012 14.671C1.82236 14.671 1.65197 14.6 1.52679 14.4738C1.40058 14.3486 1.32959 14.1782 1.32959 14.0005C1.32959 13.8227 1.40058 13.6523 1.52679 13.5271L7.06012 8.00046L1.52679 2.4738C1.35768 2.30469 1.29164 2.05822 1.35354 1.82721C1.41543 1.59621 1.59587 1.41578 1.82687 1.35388C2.05787 1.29198 2.30435 1.35803 2.47346 1.52713L8.00012 7.06046L13.5268 1.52713C13.7882 1.26572 14.212 1.26572 14.4735 1.52713C14.7349 1.78855 14.7349 2.21238 14.4735 2.4738L8.94012 8.00046L14.4735 13.5271Z"
                      fill="#FB2C36" />
                  </svg>
                }
                <p class="text-sm font-semibold">Test Case {{ $index + 1 }}</p>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.6668 7.33301V5.99967C12.6668 3.42235 10.5775 1.33301 8.00016 1.33301C5.42283 1.33301 3.3335 3.42235 3.3335 5.99967V7.33301C2.22893 7.33301 1.3335 8.22844 1.3335 9.33301V12.6663C1.3335 13.7709 2.22893 14.6663 3.3335 14.6663H12.6668C13.7714 14.6663 14.6668 13.7709 14.6668 12.6663V9.33301C14.6668 8.22844 13.7714 7.33301 12.6668 7.33301ZM4.66683 5.99967C4.66683 4.15873 6.15921 2.66634 8.00016 2.66634C9.84111 2.66634 11.3335 4.15873 11.3335 5.99967V7.33301H4.66683V5.99967ZM12.6668 13.333C13.035 13.333 13.3335 13.0345 13.3335 12.6663V9.33301C13.3335 8.96482 13.035 8.66634 12.6668 8.66634H3.3335C2.96531 8.66634 2.66683 8.96482 2.66683 9.33301V12.6663C2.66683 13.0345 2.96531 13.333 3.3335 13.333H12.6668Z"
                    fill="#99A1AF" />
                </svg>
              </div>
            </button>
          }
        }
      </div>
      <div class="flex flex-col overflow-y-auto w-full">
        @if (selectedData()) {
          @if(selectedData()?.passed) {
            <div class="text-sm bg-green-300 w-full pl-11 py-1">
              Test Result : <b>PASS</b>
            </div>
          } @else {
            <div class="text-sm bg-red-400 w-full pl-11 py-1 text-white">
              Test Result : <b>FAIL {{ selectedData()?.status }}</b>
            </div>
          }
          <div class="pl-11 flex flex-col">
            <p class="text-gray-400 text-sm">Input (stdin)</p>
            <p class="text-sm">{{ selectedData()?.input }}</p>
            <p class="text-gray-400 text-sm">Your Output (stdout)</p>
            <p class="text-sm">{{ selectedData()?.actualOutput || '&nbsp;' }}</p>
            <p class="text-gray-400 text-sm">Expected Output</p>
            <p class="text-sm">{{ selectedData()?.expected }}</p>
          </div>
        } @else {
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-center h-full">
              <div class="text-gray-500">Please select a test case.</div>
            </div>
          </div>
        }
        </div>
    </div>
  } @else {
    <div class="flex-1 min-w-0">
      <div class="flex items-center justify-center h-full">
        <div class="text-gray-500">Please run test . . .</div>
      </div>
    </div>
  }
</div>
